import template from './flight-segment-details-flight.html';

const DIRECTIVE_NAME = AtcFlightSegmentDetailsFlight.DIRECTIVE_NAME = 'ktAtcFlightSegmentDetailsFlight';
export default function AtcFlightSegmentDetailsFlight() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightSegmentDetailsFlightController,
        controllerAs: '$ctrl',
        scope: {
            flight: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            stops: `=${DIRECTIVE_NAME}Stops`,
        },
        link: function($scope, $elem, $attrs, flightSegmentDetailsFlightCtrl) {
            flightSegmentDetailsFlightCtrl.$onInit();
        },
    };
}

export function AtcFlightSegmentDetailsFlightController(
    userService,
    moment,
    l10nService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        getCompanyName,
        getCabinClass,
        moment,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        initStop();
    }

    function initStop() {
        vm.stop = vm.stops.find(({AirportCode}) => vm.flight.ArrivalAirport === AirportCode);
    }

    function getCompanyName() {
        return vm.flight.OperatingCompanyName;
    }

    function getCabinClass() {
        const cabinClass = vm.flight.CabinClass || vm.recommendation.CabinClass;
        return l10nService.localize(cabinClass);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-details-flight/flight-segment-details-flight-component.js